module.exports = __webpack_public_path__ + "img/fa_flag.95a88084.png";